import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import {
  ConfigurationSetting,
  FormatPipe,
  OffWork,
  UserActionService,
  deepCopy,
} from 'src/app/shared';
import { UserActions } from 'src/app/shared/models/user';
import { Excel, ExportRequest, InpageAliasService } from '../..';
import { ConfigurationService } from '../../services/configuration.service';
import { RecentClaimService } from '../../services/recent-claim.service';
import { UserRoleService } from '../../services/user-role.service';
import { RestrictionsDialogComponent } from './restrictions-dialog.component';
import { SubmitReturnToWorkDialogComponent } from './submit-return-to-work-dialog.component';
import { TitleCasePipe } from '@angular/common';
import { srSpeak } from 'src/app/shared';
import { TranslationRequest } from 'src/app/shared/models/translation/translation-request';

@Component({
    selector: 'app-off-work',
    providers: [FormatPipe],
    template: `
    <app-list
      [dataSource]="offWork"
      [template]="row"
      class="app-pt2"
      [filterEnabled]="true"
      [noDataIcon]="noDataIcon"
      [noDataMessage]="noDataMessage"
      [exportEnabled]="true"
      exportButtonAriaLabel="Export and download these off works as a XLSX file"
      (export)="_export()"
      [DefaultSortColumn]="isSupervisorRole ? 'from' : ''"
      [DefaultSortDir]="isSupervisorRole ? 'desc' : ''"
      [toastInfoMessage]="toastInfoMessage"
      [displayInfoToastMsg]="displayInfoToastMsg"
      [toastErrorMessage]="toasErrorMsg"
      [displayErrorToastMsg]="displayErrorToastMsg"
      [tableAriaLabel]="'OffWork'"
      >
      <ng-container header>
        <tr class="tw-flex tw-flex-wrap tw-w-full">
          <app-list-header
            name="claimDescription"
            label="Claim"
            class="tw-w-full md:tw-w-[40%]"
            [names]="['claimNumber']"
          ></app-list-header>
          <app-list-header
            name="name"
            label="Name"
            class="tw-w-full md:tw-w-[20%]"
            [names]="['firstName', 'empId']"
          ></app-list-header>
          <app-list-header
            name="from"
            label="From"
            filterType="Date"
            class="tw-w-full md:tw-w-[15%]"
          ></app-list-header>
          <app-list-header
            name="to"
            label="To"
            filterType="Date"
            class="tw-w-full md:tw-w-[15%]"
          ></app-list-header>
          <app-list-header
            label="Actions"
            readOnly
            class="tw-w-full md:tw-w-[10%]"
          ></app-list-header>
        </tr>
      </ng-container>
    </app-list>
    <ng-template #row let-element>
      <tr class="tw-flex tw-flex-wrap tw-w-full tw-items-center">
        <td class="tw-w-full md:tw-w-[40%]">
          <app-value label="Claim" layout="row-xs" [valueTemplate]="claimLabelTpl">
            <ng-template #claimLabelTpl>
              <app-claim-label
                [claim]="element"
                layout="row"
                (displayWatchListErrorMsg)="displayWatchListErrorMsg($event)"
                >
              </app-claim-label>
            </ng-template>
          </app-value>
        </td>
        <td class="tw-w-full md:tw-w-[20%]">
          <app-value label="Name" layout="row-xs" [translationNeeded]="false" [valueTemplate]="claimantLabelTpl">
            <ng-template #claimantLabelTpl>
              <app-claimant-label
                [claimant]="element"
                [disabled]="isDisabled"
              ></app-claimant-label>
            </ng-template>
          </app-value>
        </td>
        <td class="tw-w-full md:tw-w-[15%]">
          <app-value
            label="From"
            [tabindex]="element.from ? '0' : '1'"
            [value]="element.from | format:'date'"
            layout="row-xs"
            [translationNeeded]="false"
            >
          </app-value>
        </td>
        <td class="tw-w-full md:tw-w-[15%]">
          <app-value
            label="To"
            [tabindex]="element.to ? '0' : '1'"
            [value]="element.to | format:'date'"
            layout="row-xs"
            [translationNeeded]="false"
            >
          </app-value>
        </td>
        <td class="tw-w-[10%]" [attr.label]="'Actions' | translation : translationRequest">
          @if (
            (element.allowRtw || element.allowRestriction) &&
            element.source !== 'L'
            ) {
            <app-icon-button
              value
              mat-icon-button
              [matMenuTriggerFor]="menu"
              [ariaLabelText]="'Actions menu for claim'"
              [ariaLabelTextNoTranslation] = "' - ' + element.claimLabel"
              label="{{'Actions'}}"
              icon="more_vert"
              tabindex="0"
              role="button"
              (click)="toggleMenu()"
              (keydown.enter)="toggleMenu()"
              [attr.aria-label]="'Actions menu for claim - ' + element.claimLabel"
              [attr.aria-expanded]="isActionsMenuExpanded"
              >
              <mat-menu #menu="matMenu" role="menu" (closed)="toggleMenu()">
                <div class="radius-10">
                  @if (element.allowRtw) {
                    <a
                      class="tw-w-full app-pl2 app-lc-sticky-link"
                      [attr.aria-label]="'Report return to Work Date' | translation : translationRequest"
                      mat-menu-item
                      role="menuitem"
                      routerLink="/return-to-work"
                  [queryParams]="{
                    claimId: element.claimId,
                    source: element.source,
                    rtw: 'submit'
                  }"
                      >
                      {{'Report return to work' | translation : translationRequest}}
                    </a>
                  }
                  @if (
                    (isSupervisorRole || isController) &&
                    element.lineOfBusiness === 'WC' &&
                    element.allowRestriction
                    ) {
                    <a
                      class="tw-w-full app-pl2 app-lc-sticky-link"
                      mat-menu-item
                      role="menuitem"
                      [attr.aria-label]="'View Restrictions' | translation : translationRequest"
                      (click)="openRestrictionComponent(element)"
                      (keypress.enter)="openRestrictionComponent(element)"
                      >
                      {{'View Restrictions' | translation : translationRequest}}
                    </a>
                  }
                </div>
              </mat-menu>
            </app-icon-button>
          }
        </td>
      </tr>
    </ng-template>
    `,
    styles: [
        `
      #restrictionpnl ::ng-deep .mat-mdc-unelevated-button.mat-accent {
        background-color: #007dbc !important;
        color: #fff;
      }

      .pd-10 {
        padding-right: 10px;
      }
      #restrictionpnl ::ng-deep .mat-mdc-unelevated-button.mat-accent:hover {
        background-color: #035e81 !important;
      }
    `,
    ],
    standalone: false
})
export class OffWorkComponent implements OnInit {
  @Input()
  offWork: OffWork[];

  @Input()
  translationRequest: TranslationRequest;

  @Input()
  yourClaim?: boolean = false;

  displayToastMsg: boolean = false;
  displayInfoToastMsg: boolean = false;
  displayErrorToastMsg: boolean = false;
  toastInfoMessage: string;
  toasErrorMsg: string;
  userAction = UserActions.ViewOwnMgrDb;
  isDisabled: boolean;
  noDataIcon: string = 'work_outline';
  noDataMessage: string = 'No employees off work';
  isActionsMenuExpanded: boolean = false;
  employeeAlias: string;

  @Input()
  ClientLevelConfig: ConfigurationSetting;

  @Output()
  export = new EventEmitter<ExportRequest>();

  isSupervisorRole: boolean = false;
  isController: boolean = false;
  constructor(
    public dialog: MatDialog,
    public ClientLevelConfigService: ConfigurationService,
    private recentClaimService: RecentClaimService,
    public userRole: UserRoleService,
    private excel: Excel,
    private userActions: UserActionService,
    private formatpipe: FormatPipe,
    private aliases: InpageAliasService
  ) {}

  async ngOnInit() {
    this.employeeAlias = await this.aliases.get('employeePlural');
    this.noDataMessage = `No ${this.employeeAlias ?? 'employees'} off work`;
    this.isSupervisorRole = this.userRole.manager;
    this.isController = this.userRole.controller;
    if (
      (this.userActions.getAction() == UserActions.ViewOwnMgrDb ||
        this.userRole.manager) &&
      !this.userRole.controller
    ) {
      this.isDisabled = window.location.pathname === '/dashboard';
    } else {
      this.isDisabled = true;
    }
    if (this.offWork?.length > 200) {
      this.displayInfoToastMsg = true;
      this.toastInfoMessage =
        'Please use the Search page to find a claim that does not have an off work record in this list.';
    }
  }

  openRtwComponent(claim: any): void {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      claim: claim,
      yourClaim: this.yourClaim,
      uploadFile: claim.allowUploadDocuments,
    };

    this.dialog.open(SubmitReturnToWorkDialogComponent, dialogConfig);
  }

  openRestrictionComponent(claim: any): void {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      restrctions: claim.restrictionsTable,
    };

    this.dialog.open(RestrictionsDialogComponent, dialogConfig);
  }

  displayWatchListErrorMsg(event: any) {
    this.displayErrorToastMsg = true;
    this.toasErrorMsg =
      this.recentClaimService.displayWatchListErrorMsg1(event);
  }

  async _export() {
    const formattedData = deepCopy(this.offWork);
    const titleCase = new TitleCasePipe();
    const aliasLabel = titleCase.transform(this.employeeAlias ?? 'employees');
    for (const off of formattedData) {
      const formatName = (off.name += '');
      if (formatName && formatName.length > 0 && formatName.indexOf(' ') > -1) {
        const arr1 = formatName.split(' ').map((item) => item.trim());
        off.name = arr1.map((x) => titleCase.transform(x)).join(' ');
      }
      // Format dates for export (MM/DD/YYYY)
/*       if (off?.from) {
        off.from = this.formatpipe.transform(off.from, 'date');
      }
      if (off?.to) {
        off.to = this.formatpipe.transform(off.to, 'date');
      } */
    }
    const request = new ExportRequest();
    request.fileName = `${aliasLabel} off work`;
    request.sheets = [
      {
        name: `${aliasLabel} off work`,
        rows: formattedData,
        headers: [
          { label: 'Line of Business', value: 'lineOfBusiness' },
          { label: 'Claim Type', value: 'claimDescription' },
          { label: 'Claim Number', value: 'claimNumber' },
          { label: 'First Name', value: 'name', format: 'first' },
          { label: 'Last Name', value: 'name', format: 'last' },
          { label: 'Employee ID', value: 'empId' },
          {
            label: 'From date',
            value: 'from',
            format: 'date',
          },
          {
            label: 'To date',
            value: 'to',
            format: 'date',
          },
        ],
      },
    ];
    this.export.emit(request);
    await this.excel.export(request, ['claimDescription'], '.xlsx');
  }

  toggleMenu() {
    this.isActionsMenuExpanded = !this.isActionsMenuExpanded;
    if (this.isActionsMenuExpanded) {
      srSpeak('expanded', 'polite');
    }
  }
}
